import { useCallback } from 'react';
import { useTableStore } from './selectTableStore';
import { adminAPI } from 'services/admin';
// import { useNavigate } from 'react-router-dom';

export const useTable = ({ url, listKey }) => {
  const {
    setIsLoading,
    setCount,
    setData,
    selectedItems,
    data,
    setSelectedItemsByListId,
  } = useTableStore();
  // const navigate = useNavigate();

  const getDataTable = useCallback(
    async ({ page = 0, filter = '' } = {}) => {
      setIsLoading(true);
      try {
        const offset = page * 10;
        const path = `${url}${offset}${filter ? `&${filter}` : ''}`;
        const response = await adminAPI.get(path);

        setCount(response.totalItemsCountFiltered);
        setData(response[listKey]);
        console.log(JSON.stringify(response))


        return response;
      } catch (error) {
        // navigate('/login');
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [listKey, url]
  );

  const onChangeSelected = (listId, selected) => {
    const allSelectedData = [
      ...(selectedItems?.[listId] || []),
      ...data,
    ].reduce((acc, currentValue) => {
      if (selected[currentValue.id]) {
        return { ...acc, [currentValue.id]: currentValue };
      }
      return acc;
    }, {});

    setSelectedItemsByListId(listId, Object.values(allSelectedData));
  };

  return {
    onChangeSelected,
    getDataTable,
  };
};
